var React = require('react');

function Notes (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.623047 2.81738C0.623047 1.71281 1.51848 0.817383 2.62305 0.817383H13.51C14.6146 0.817383 15.51 1.71281 15.51 2.81738V8.08828L8.06451 16.1025H2.62305C1.51848 16.1025 0.623047 15.2071 0.623047 14.1025V2.81738Z","fill":"#B3A1BC","key":0}),React.createElement("path",{"d":"M8.06681 16.1025L8.06681 10.0799C8.06681 8.97535 8.96224 8.07992 10.0668 8.07992L15.5156 8.07992L8.06681 16.1025Z","fill":"#432D4E","key":1})]);
}

Notes.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Notes;

Notes.default = Notes;
